import { useEffect, useRef, useState } from "react";

/** Rename in place: Return keeps, Escape cancels, leaving the field keeps. The text starts selected. */
export function RenameField({
  value,
  label,
  onDone,
}: {
  value: string;
  label: string;
  /** the new name, or null when cancelled */
  onDone: (name: string | null) => void;
}) {
  const [draft, setDraft] = useState(value);
  const ref = useRef<HTMLInputElement>(null);
  const done = useRef(false);
  useEffect(() => {
    ref.current?.focus();
    ref.current?.select();
  }, []);
  const finish = (n: string | null) => {
    if (done.current) return;
    done.current = true;
    onDone(n === null || !n.trim() || n.trim() === value ? null : n.trim());
  };
  return (
    <input
      ref={ref}
      className="rename"
      aria-label={label}
      value={draft}
      maxLength={120}
      onChange={(e) => setDraft(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
      onBlur={() => finish(draft)}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === "Enter") finish(draft);
        else if (e.key === "Escape") finish(null);
      }}
    />
  );
}
